import { z } from 'zod';

/** Wire format for POST /v1/auth/magic-link/request (BFF uses `next`; users uses `redirect_path`). */
export const MagicLinkRequestBodySchema = z.object({
  email: z.string().email(),
  next: z.string().optional(),
});

export const MagicLinkRequestUpstreamSchema = z.object({
  email: z.string().email(),
  redirect_path: z.string().optional(),
});

export const MagicLinkVerifyBodySchema = z.object({
  token: z.string().min(16),
});

export const UpdateProfileBodySchema = z.object({
  first_name: z.string().min(1).max(100),
  last_name: z.string().min(1).max(100),
  phone: z.string().max(50).optional(),
});

export const MagicLinkRequestResponseSchema = z.object({
  data: z.object({
    sent: z.literal(true),
  }),
});

/** Mirrors `tss-svc-communication` `SendTemplatedEmailSchema` (domain/email-template.ts). */
export const SendTemplatedEmailSchema = z.object({
  template_slug: z.string().min(1).max(100),
  to_email: z.string().email(),
  variables: z.record(z.string(), z.string()).default({}),
  metadata: z.record(z.string(), z.string()).optional(),
});

export const MAGIC_LINK_TEMPLATE_SLUG = 'magic_link_login' as const;

export const MagicLinkEmailVariablesSchema = z.object({
  magic_link_url: z.string().url(),
  user_email: z.string().email(),
  store_name: z.string().min(1),
  expires_minutes: z.string().regex(/^\d+$/),
});

/** Mirrors communication GET `/v1/integrations/email/smtp` response `data` shape. */
export const CommunicationSmtpConfigSchema = z.object({
  configured: z.boolean(),
  password_configured: z.boolean(),
});

export const CommunicationSmtpConfigEnvelopeSchema = z.object({
  data: CommunicationSmtpConfigSchema,
});

export interface DisplayNameProfile {
  firstName?: string;
  lastName?: string;
}

export function toDisplayName(email: string, profile: DisplayNameProfile): string {
  const first = profile.firstName?.trim();
  if (first) {
    const last = profile.lastName?.trim();
    return last ? `${first} ${last}` : first;
  }
  return email;
}

export type MagicLinkRequestBody = z.infer<typeof MagicLinkRequestBodySchema>;
export type MagicLinkRequestUpstream = z.infer<typeof MagicLinkRequestUpstreamSchema>;
export type MagicLinkVerifyBody = z.infer<typeof MagicLinkVerifyBodySchema>;
export type UpdateProfileBody = z.infer<typeof UpdateProfileBodySchema>;
